var $=jQuery;
jQuery(document).ready(function ($) {

    updateModelText();
    $(document).on('change', 'input[name^="Größe-2"]', function() {
        updateModelText();
    });
    function updateModelText() {
      var selectedSize = $('input[name^="Größe-2"]:checked').val();
      if (selectedSize) {
          $('.model_block_text').text(selectedSize);
          console.log(selectedSize);
      }
  }
  $(".size-chart-trigger").on("click", function() {
    $("#sizeChartModal").fadeIn(200);
  });

  $(".size-chart-close, .size-chart-overlay").on("click", function() {
    $("#sizeChartModal").fadeOut(200);
  });

    $('.mobile-facets__summary label[for="SortBy-mobile"]').on('click', function() {
    $(this).toggleClass('active');
  });

  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  if ($(window).width() < 950) {
    $(".count-box").flickity({
        pageDots: true,
        freeScroll: false,
        // wrapAround: true,
        prevNextButtons: false,
        autoPlay: 10000,
        groupCells: false,
        cellAlign: 'left',
    });
  }
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  var counted = false;
  if ($('.counter').length > 0) {
  $(window).on('scroll', function () {
    var $counter = $('.counter');
    if (isScrolledIntoView($counter) && !counted) {
      counted = true;

      $('.counter').each(function () {
        var show = '';
        var $this = $(this),
            countTo = $this.attr('data-count');
            show = $(this).attr('data-show');
    
        $({ countNum: $this.text() }).animate({
          countNum: countTo,
        },
        {
          duration: 2000,
          easing: 'swing',
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(show);
          }
        });
      });
    }
  });
}

    $('.acc-head').on('click', function() {
       if($(this).hasClass('active')) {
         $(this).siblings('.acc-content').slideUp();
         $(this).removeClass('active');
       }
       else {
       $('.acc-content').slideUp();
       $('.acc-head').removeClass('active');
       $(this).siblings('.acc-content').slideToggle();
       $(this).toggleClass('active');
     }
   });
  
});


//price custom
class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      // Event listeners for text input focus and change
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      // Event listeners for range slider change and input
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
}
window.customElements.define("price-range1", PriceRange1);
